<template>
  <div class="inspection-route-map-container">
    <div id="inspectionRouteMap" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script>
import { listInspectionRoutePoints } from '@/api/inspection/inspectionPointApi'
import { getCommunityId } from '@/api/community/communityApi'
import {
  DEFAULT_MAP_CENTER,
  addTiandituLabel,
  addTiandituMarker,
  addTiandituPolyline,
  clearTiandituMap,
  fitTiandituViewport,
  loadTiandituMapScript,
} from '@/utils/tiandituMap'

export default {
  name: 'InspectionRouteMap',
  data() {
    return {
      map: null,
      communityId: '',
      routePoints: []
    }
  },
  async mounted() {
    this.communityId = getCommunityId()
    // 延迟初始化地图，确保DOM已经渲染
  },
  methods: {
    async loadData(route) {
      const ready = await this.initMap()
      if (ready) {
        await this.loadRoute(route)
      }
    },

    async initMap() {
      clearTiandituMap(this.map)
      this.map = null
      try {
        await loadTiandituMapScript()
        const center = new window.T.LngLat(DEFAULT_MAP_CENTER.lng, DEFAULT_MAP_CENTER.lat)
        this.map = new window.T.Map('inspectionRouteMap', {
          projection: 'EPSG:4326',
        })
        this.map.centerAndZoom(center, 13)
        return true
      } catch (error) {
        console.error('天地图加载失败:', error)
        this.$message.error(this.$t('tiandituMap.loadFailed'))
        return false
      }
    },

    async loadRoute(route) {
      if (!route || !route.inspectionRouteId) return

      try {
        const params = {
          communityId: this.communityId,
          inspectionRouteId: route.inspectionRouteId,
          page: 1,
          row: 1000
        }

        const response = await listInspectionRoutePoints(params)
        this.routePoints = response.inspectionPoints
        this.addPointsToMap(this.routePoints)
      } catch (error) {
        console.error('获取路线点失败:', error)
        this.$message.error(this.$t('inspectionRouteMap.fetchError'))
      }
    },

    addPointsToMap(points) {
      if (!this.map || !points || points.length === 0) return

      clearTiandituMap(this.map)
      const path = []

      points.forEach(point => {
        if (!point.lat || !point.lng) return
        const result = addTiandituMarker(this.map, point, {
          title: point.inspectionName,
          iconUrl: '/img/maper.png',
        })
        if (!result) return
        addTiandituLabel(this.map, result.lngLat, point.inspectionName)
        path.push(result.lngLat)
      })
      addTiandituPolyline(this.map, path)
      fitTiandituViewport(this.map, path)
    }
  },
  beforeDestroy() {
    clearTiandituMap(this.map)
    this.map = null
  }
}
</script>

<style scoped>
.inspection-route-map-container {
  width: 100%;
  height: 100%;
}
</style>
